var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "app-main-inner",
      attrs: {
        visible: _vm.innerVisible,
        width: "800px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.cancel
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "header-title",
          attrs: { slot: "title" },
          slot: "title"
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                "line-height": "24px",
                "font-size": "15px",
                "font-weight": "bold",
                color: "#333333"
              }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Tips")))]
          ),
          _vm.reminderFlag === 0
            ? _c(
                "span",
                {
                  staticStyle: {
                    color: "#ffaa00",
                    "padding-left": "10px",
                    "padding-right": "6px",
                    "font-size": "15px",
                    "font-weight": "bold"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.BUSINESS_CAN_ARCHIVED")))]
              )
            : _vm.reminderFlag === 1
            ? _c(
                "span",
                {
                  staticStyle: {
                    color: "#ffaa00",
                    "padding-left": "10px",
                    "padding-right": "6px",
                    "font-size": "15px",
                    "font-weight": "bold"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.NOT_FULLY_COMPLETED")))]
              )
            : _vm.reminderFlag === 2
            ? _c(
                "span",
                {
                  staticStyle: {
                    color: "#ffaa00",
                    "padding-left": "10px",
                    "padding-right": "6px",
                    "font-size": "15px",
                    "font-weight": "bold"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.NON_FILEABLE_BUSINESS")))]
              )
            : _vm._e()
        ]
      ),
      _c(
        "div",
        { staticClass: "section grid-wrapper" },
        [
          _c("cargo-ag-grid", {
            attrs: {
              "config-module": "190912",
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "grid-params": _vm.gridParams,
              "row-data": _vm.data
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: {
                no: "1",
                type: "primary",
                size: "mini",
                disabled: _vm.reminderFlag === 2
              },
              on: { click: _vm.confirm }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ConfirmR")))]
          ),
          _c(
            "el-button",
            { attrs: { no: "2", size: "mini" }, on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }